import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
  onActivated,
  onBeforeMount,
  onBeforeUnmount,
  onDeactivated,
  onMounted,
  ref,
} from 'vue'
import type { Raw } from 'vue'

import { HeaderView } from '@/models/header'
import { useHardGateBilling20516Active } from '@/app/composables/useHardGateBilling20516'

import AppMenu from '@/app/components/header/AppMenu.vue'

const NAVBAR_HEIGHT_PROPERTY = '--navbar-mobile-height'

export default /*@__PURE__*/_defineComponent({
  __name: 'AppMobile',
  setup(__props) {

const view = ref<Raw<HeaderView>>(new HeaderView())
const hardGate20516Active = useHardGateBilling20516Active()

onBeforeMount(async () => {
  await view.value.init()
})

// Publish the navbar's height so fixed elements (e.g. bottom toasts)
// can sit above it. The height is 0 when the navbar is hidden on desktop.
const navbar = ref<HTMLElement | null>(null)
let resizeObserver: ResizeObserver | null = null

function updateNavbarHeight(): void {
  document.documentElement.style.setProperty(
    NAVBAR_HEIGHT_PROPERTY,
    `${navbar.value?.offsetHeight ?? 0}px`,
  )
}

function startPublishingHeight(): void {
  // On the first mount of a cached page, `onMounted` and `onActivated` both
  // run. So before we create the observer, stop publishing so that there will
  // only be one observer active at a time.
  stopPublishingHeight()
  updateNavbarHeight()
  if (typeof ResizeObserver !== 'undefined' && navbar.value) {
    resizeObserver = new ResizeObserver(updateNavbarHeight)
    resizeObserver.observe(navbar.value)
  }
}

function stopPublishingHeight(): void {
  resizeObserver?.disconnect()
  resizeObserver = null
  document.documentElement.style.removeProperty(NAVBAR_HEIGHT_PROPERTY)
}

// All pages have onMounted and onBeforeUnmount, but for pages cached with
// `KeepAlive` (e.g. Books browse), they are
// - activated but not mounted on renders after the first one
// - deactivated rather than unmounted when you leave them
// So we add onActivated and onDeactivated here.
onMounted(startPublishingHeight)
onActivated(startPublishingHeight)
onDeactivated(stopPublishingHeight)
onBeforeUnmount(stopPublishingHeight)

return (_ctx: any,_cache: any) => {
  return (!_unref(hardGate20516Active))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "navbar",
        ref: navbar,
        class: _normalizeClass(["navbar-mobile", { 'navbar-mobile--ios': view.value?.isIOS }])
      }, [
        _createVNode(AppMenu, { view: view.value }, null, 8, ["view"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})